import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import {
  getWashiHumanCapitalUniquenessDbPageConfig,
  getWashiValueAddedProductivityDbPageConfig,
} from './human-capital-management-db-page-configs';

const dashboardId = 'human-capital-management';

export const WashiHumanCapitalManagementDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Human Capital Management ',
    [Languages.JA]: '人的資本経営ダッシュボード',
  },
  enabled: true,
  pages: [
    getWashiValueAddedProductivityDbPageConfig({
      pageId: 1,
      dashboardId,
      title: {
        [Languages.EN]: 'Value-added Productivity',
        [Languages.JA]: '付加価値生産性',
      },
    }),
    getWashiHumanCapitalUniquenessDbPageConfig({
      pageId: 2,
      dashboardId,
      title: {
        [Languages.EN]: 'Human Capital Uniqueness',
        [Languages.JA]: '人的資本の独自性',
      },
    }),
  ],
};
